import { c as _c } from "react/compiler-runtime";
import React from "react";
const PreviewImagePopup = t0 => {
  const $ = _c(15);
  const {
    onClose,
    previewImage
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = e => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleBackdropClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-[16px] sm:text-[18px] font-poppins font-semibold text-[#1F1F1F]">Image Preview</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect width="24" height="24" fill="white" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M5.00049 17.5864C4.60999 17.977 4.61005 18.6101 5.00061 19.0006C5.39117 19.3911 6.02433 19.3911 6.41482 19.0005L12.0001 13.4143L17.5858 19C17.9763 19.3905 18.6095 19.3905 19 19C19.3905 18.6095 19.3905 17.9763 19 17.5858L13.4142 12L18.9996 6.41359C19.39 6.02303 19.39 5.38987 18.9994 4.99938C18.6089 4.60888 17.9757 4.60894 17.5852 4.9995L11.9999 10.5858L6.41414 4.99998C6.02362 4.60946 5.39045 4.60946 4.99993 4.99998C4.6094 5.39051 4.6094 6.02367 4.99993 6.4142L10.5859 12.0001L5.00049 17.5864Z" fill="#8E8E8E" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClose) {
    t5 = <div className="flex w-full px-4 pt-4 pb-3 border-b border-[#E1E1E1] justify-between items-center flex-shrink-0">{t2}<svg onClick={onClose} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">{t3}{t4}</svg></div>;
    $[5] = onClose;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = previewImage || "/Images/default-profile-pic.svg";
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="flex-1 flex justify-center items-center w-full p-4 min-h-0"><img src={t6} className="max-w-full max-h-full sm:max-h-[70vh] object-contain rounded-lg" alt="preview image" /></div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <div className="w-full h-full sm:w-[600px] sm:h-auto sm:max-h-[90vh] relative bg-white rounded-none sm:rounded-2xl shadow sm:border sm:border-neutral-200 flex flex-col">{t5}{t7}</div>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== handleBackdropClick || $[13] !== t8) {
    t9 = <><div className="fixed inset-0 popup-bg z-[9999] flex justify-center items-center" onClick={handleBackdropClick}>{t8}</div></>;
    $[12] = handleBackdropClick;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default PreviewImagePopup;